import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { StarredCellRendererModule, Y42AgGridModule } from '@y42/ag-grid';
import { ColumnTypeModule } from '@y42/column-type';
import { FormatValueConversionModule } from '@y42/core/format-value-conversion';
import { IntercomTargetModule } from '@y42/intercom';
import { NgxEchartsModule } from 'ngx-echarts';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { FunctionEditorModule } from '../../../function-editor';
import { HeaderRendererModule } from '../../../header-renderer';
import { OperationInputAgFilterModule } from '../../../operation-input';
import { ScrollbarWrapperModule } from '../scrollbar-wrapper/scrollbar-wrapper.module';
import { AgGridIntercomTargetDirective } from './ag-grid-intercom-target.directive';
import { TableColumnStatsComponent } from './components/table-column-stats/table-column-stats.component';
import { TableFooterComponent } from './components/table-footer/table-footer.component';
import { TableDataAgGridComponent } from './table-data-ag-grid.component';

@NgModule({
  declarations: [
    TableDataAgGridComponent,
    AgGridIntercomTargetDirective,
    TableColumnStatsComponent,
    TableFooterComponent,
  ],
  imports: [
    CommonModule,
    MatInputModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatSlideToggleModule,
    MatChipsModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    MatSidenavModule,
    FormsModule,
    MatIconModule,
    FontAwesomeModule,
    IntercomTargetModule,
    ColumnTypeModule,
    FormatValueConversionModule,
    NgxJsonViewerModule,
    ScrollbarWrapperModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts'),
    }),
    HeaderRendererModule,
    Y42AgGridModule,
    FunctionEditorModule,
    OperationInputAgFilterModule,
    StarredCellRendererModule,
  ],
  exports: [TableDataAgGridComponent],
})
export class TableDataAgGridModule {}
